import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard, List, PlusCircle, MessageSquare, HandCoins, Heart, UserCog, Settings, ClipboardList, Bookmark,
} from "lucide-react";
import { cn } from "@/lib/utils";

const MENU = [
  { to: "/panel", end: true, label: "Panel", icon: LayoutDashboard },
  { to: "/panel/ilanlarim", label: "İlanlarım", icon: List },
  { to: "/panel/yeni-ilan", label: "Yeni İlan", icon: PlusCircle },
  { to: "/panel/mesajlar", label: "Mesajlar", icon: MessageSquare },
  { to: "/panel/teklifler", label: "Gelen Teklifler", icon: HandCoins },
  { to: "/panel/tekliflerim", label: "Tekliflerim", icon: HandCoins },
  { to: "/panel/alim-taleplerim", label: "Alım Taleplerim", icon: ClipboardList },
  { to: "/panel/favoriler", label: "Favoriler", icon: Heart },
  { to: "/panel/aramalar", label: "Kayıtlı Aramalar", icon: Bookmark },
  { to: "/panel/profil", label: "Profilim", icon: UserCog },
  { to: "/panel/ayarlar", label: "Hesap Ayarları", icon: Settings },
];

export default function DashboardLayout() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-6 lg:px-6 lg:py-8">
      {/* Mobile horizontal nav */}
      <nav className="mb-4 flex gap-2 overflow-x-auto no-scrollbar lg:hidden">
        {MENU.map((m) => (
          <NavLink key={m.to} to={m.to} end={m.end}
            className={({ isActive }) => cn(
              "flex shrink-0 items-center gap-1.5 rounded-full border px-3 py-2 text-xs font-medium",
              isActive ? "border-emerald-600 bg-emerald-50 text-emerald-700" : "border-slate-200 text-slate-600"
            )}>
            <m.icon size={15} /> {m.label}
          </NavLink>
        ))}
      </nav>

      <div className="flex gap-8">
        <aside className="hidden w-60 shrink-0 lg:block">
          <nav className="sticky top-32 space-y-1">
            {MENU.map((m) => (
              <NavLink key={m.to} to={m.to} end={m.end} data-testid={`dash-nav-${m.to.split("/").pop() || "home"}`}
                className={({ isActive }) => cn(
                  "flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                  isActive ? "bg-emerald-50 text-emerald-700" : "text-slate-600 hover:bg-slate-50"
                )}>
                <m.icon size={18} /> {m.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <div className="min-w-0 flex-1"><Outlet /></div>
      </div>
    </div>
  );
}
